<ng-container *mobxAutorun>
  <nav class="nav flex-column" role="navigation">
    <!-- Small screen: hide tree-nav button -->
    <div class="tree-nav-actions d-md-none">
      <button class="tree-nav-hide close" (click)="hideTreeNav()">
        &times;
      </button>
    </div>

    <!-- Recursively render tree entries -->
    <lf-tree-entry *ngIf="_hasRoutes" [path]="path"></lf-tree-entry>
  </nav>
</ng-container>
